export const membershipOptions = {
  JOIN_AS_MEMBERSHIP: 'join as member',
  DO_NOT_JOIN_AS_MEMBER: 'do not join'
}
export const userRoleOptions = {
  POWER_USER: 'PowerUser'
}

export const projectMenuErrorMessages = {
  PROJECT_NAME_IS_NOT_AVAILABLE: 'Project name is not available',
  FOLDER_NAME_IS_NOT_AVAILABLE: 'Folder name is not available',
  PLAN_NAME_IS_NOT_AVAILABLE: 'Plan name is not available'
}

export const projectMenuApiErrorCodeOptions = {
  NO_PERMISSION_TO_CREATE_PROJECT_OR_FOLDER: 403,
  PROJECT_NAME_IS_NOT_AVAILABLE: 409,
  FOLDER_NAME_IS_NOT_AVAILABLE: 409,
  PLAN_NAME_IS_NOT_AVAILABLE: 409,
  FOLDER_NO_LOGER_EXISTS: 400
}

export const viewTypeOptions = {
  LIST_VIEW: 'list',
  TILE_VIEW: 'tiles'
}

export const projectMenuItemTypeOptions = {
  PROJECT: 'Project',
  FOLDER: 'Folder'
}

export const projectMenuTabOptions = {
  MY_PROJECTS: 'my-projects',
  COMPANY_PROJECTS: 'company-projects'
}
